<template>
  <div class="Detail-minProgram-panel">
      <div class="minProgram-panel">
        <div class="new-share-minImg">
          <div class="manage-btn-box">
            <div class="btn-manage" @click="toShare(1)">
              <img
                class="btn-manage-ic"
                src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20230913/93ae9f49fba281e6a9989cab732d6175.png"
              />
              <div class="btn-text">分享图</div>
            </div>
            <div class="btn-manage" @click="toShare(0, 1)">
              <img
                class="btn-manage-ic"
                src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20230913/69a5bfce0e4bc6298736668c8d65e001.png"
              />
              <div class="btn-text">小程序码</div>
            </div>
            <div class="btn-manage" @click="toShare(0, 2)">
              <img
                class="btn-manage-ic"
                src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20230913/b0ccbe0f6b60e05948c9c829bd251b06.png"
              />
              <div class="btn-text">二维码</div>
            </div>
            <div class="btn-manage" @click="toShare(3)">
              <img
                class="btn-manage-ic"
                src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20230913/c5ab9cea18be4de6736df36735ce123f.png"
              />
              <div class="btn-text">嵌入公众号</div>
            </div>
            <div
              class="btn-manage"
              @click="toShare(2)"
            >
              <img
                class="btn-manage-ic"
                src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20230913/fed54c5879c4abfcd06a3038baf54073.png"
              />
              <div class="btn-text">H5链接</div>
            </div>
          </div>
          <div class="button-white" @click="close()">取消</div>
        </div>
      </div>
    </div>
</template>

<script>
import { getQrcodeFn } from "../utils/common";
import html2canvas from "html2canvas";
import { Toast } from "vant";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default: {}
    }
  },
  watch: {
  },
  data() {
    return {
      show: false,
      applet_code: "",
      qr_code: "",
      share_img: "",
      tabIndex: 1,
      tabBgImgs: [
        "https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-11-03/5f94b30e7b3136ab4e3405e360c0e1d9.png",
        "https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-11-03/7a71b868ccb31a3fe8e35c562478ffea.png",
        "https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-11-03/722f971b0a88b1c6fa35699bd1246cca.png",
        "https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-11-03/9f62ed132d5010da180cb75d36fc970e.png"
      ],
      codeType: 0,
      qrcode: "",
      logo: "",
      default_banner: "https://cdn-xcx-qunsou.weiyoubot.cn/material/20220401/fb739273691cc885856d20a81c2b90bb.jpg",
      prurl: "",
      h5Url: ""
    };
  },
  methods: {
    toShare(type, index) {
      this.$router.push({
        name: 'sharebox',
        query: {
          qid: this.info.qid,
          type,
          index
        }
      })
    },
    close() {
      this.$emit("hideVisible");
    }
  }
};
</script>

<style lang="scss" scoped>
.Detail-minProgram-panel {
  position: relative;
  overflow: hidden;
  height: 140px;
  .share-choice-mask {
    position: fixed;
    // z-index: 101;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .minProgram-panel {
    width: 100%;
    // position: fixed;
    // z-index: 102;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    font-size: 14px;
    .new-share-minImg {
      position: relative;
      width: 100%;
      max-width: 500px;
      min-width: 320px;
      background-color: #ffffff;
      box-sizing: border-box;
      padding-bottom: env(safe-area-inset-bottom);
      overflow: hidden;
      .manage-btn-box {
        display: flex;
        width: 100%;
        flex-wrap: wrap;
        padding-top: 20px;
      }
      .btn-manage {
        text-align: center;
        font-size: 12px;
        color: #000;
        width: 20%;
        margin-bottom: 20px;
        cursor: pointer;
      }
      .btn-manage-ic {
        width: 24px;
        height: 24px;
        padding-bottom: 8px;
      }
      .button-white {
        background: #f5f6f7;
        color: #000;
        font-size: 15px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        cursor: pointer;
      }

      .preview-img {
        margin: 0 24px 24px;
        background-size: cover;
        position: relative;
        width: 300px;
        min-width: 300px;
        height: 424px;
        box-sizing: border-box;
      }
      .preview-img.tall {
        height: 545px;
        border: 1px solid #eee;
      }
      .preview-cover {
        width: 300px;
        min-width: 300px;
        position: absolute;
        left: 0;
        top: 0;
      }
      .pre0-top {
        height: 103px;
        margin: 0 12px 12px;
        padding: 40px 12px 20px;
        z-index: 3;
        border-radius: 6.4px;
        box-sizing: border-box;
      }
      .pre1-top {
        margin: 0 12px 0;
        padding: 40px 12px 10px;
        z-index: 3;
        border-radius: 6.4px;
      }
      .pre1-title,
      .pre0-title {
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
        height: 42px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .pre2-title {
        font-size: 18px;
        font-weight: 500;
        margin: 10px 40px 0;
        color: #3d3d3d;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }
      .pre3-title {
        font-size: 24px;
        font-weight: 500;
        margin: 154px 40px 0;
        color: #3d3d3d;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 5;
        -webkit-box-orient: vertical;
      }
      .pre1-joined {
        font-size: 12px;
        color: #666666;
        margin-top: 10px;
      }
      .pre0-avatar,
      .pre1-avatar,
      .pre2-avatar,
      .pre3-avatar {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        background-size: cover;
        object-fit: cover;
      }
      .pre1-avatar {
        width: 40px;
        height: 40px;
        border: 1px solid #fff;
      }

      .pre0-avatar {
        border: 1px solid #ffffff;
        box-sizing: border-box;
        margin-left: 24px;
        display: block;
        margin-top: 24px;
      }
      .pre2-avatar,
      .pre3-avatar {
        margin-left: 8px;
        margin-top: 18px;
      }
      .pre0-name {
        padding-top: 48px;
        margin-left: 8px;
        margin-right: 30px;
        font-size: 14px;
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
      .pre1-name {
        margin-left: 8px;
        font-size: 14px;
      }
      .pre1-name .font500 {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        width: 140px;
      }
      .pre2-name,
      .pre3-name {
        margin: 18px 8px 0;
        font-size: 14px;
        font-weight: 500;
        color: #fff;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .pre0-qrcode {
        margin-top: 10px;
        text-align: center;
      }
      .pre0-qrcode,
      .pre1-qrcode,
      .pre2-qrcode,
      .pre3-qrcode {
        position: relative;
      }
      // .pre2-qrcode, .pre3-qrcode {
      //   top: -12px;
      // }
      .pre0-qrcode-out {
        width: 128px;
        height: 128px;
      }

      .pre1-qrcode-out {
        width: 64px;
        height: 64px;
        margin: 5px 0 0 0;
      }
      .pre2-qrcode-out {
        margin: 0 0 0 0;
      }

      .pre2-qrcode-out,
      .pre3-qrcode-out {
        width: 60px;
        height: 60px;
      }
      .pre0-qrcode .code-type1 {
        left: 121px;
        top: 35px;
        width: 58px;
        height: 58px;
      }
      .pre0-qrcode .code-type2 {
        width: 25px;
        height: 25px;
        left: 137px;
        top: 53px;
      }
      .pre1-qrcode .code-type1 {
        left: 17px;
        top: 17px;
        width: 30px;
        height: 30px;
      }
      .pre1-qrcode .code-type2 {
        width: 13px;
        height: 13px;
        left: 27px;
        top: 27px;
      }

      .pre2-qrcode .code-type1 {
        left: 16px;
        top: 16px;
        width: 28px;
        height: 28px;
      }
      .pre2-qrcode .code-type2 {
        width: 13px;
        height: 13px;
        top: 23px;
        left: 23px;
      }

      .pre3-qrcode .code-type1 {
        left: 16px;
        top: 16px;
        width: 28px;
        height: 28px;
      }
      .pre3-qrcode .code-type2 {
        width: 13px;
        height: 13px;
        top: 23px;
        left: 23px;
      }
      .pre0-invite {
        font-size: 12px;
        color: #666666;
        text-align: center;
        margin-top: 10px;
      }
      .pre1-invite {
        margin: 40px 24px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .pre0-footer,
      .pre1-footer {
        img {
          width: 16px;
          height: 16px;
          margin-right: 4px;
        }
        span{
          opacity: .9;
          font-size: 12px;
        }
      }
      .pre0-footer {
        text-align: center;
        font-size: 12px;
        margin-top: 37px;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .pre1-footer {
        text-align: center;
        font-size: 12px;
        margin-top: 21px;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .pre2-footer,
      .pre3-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 12px 0;
        font-size: 12px;
        position: absolute;
        bottom: 8px;
        right: 0;
        left: 0;
        .tip1 {
          color: #1890ff;
        }
        .tip2 {
          color: #666666;
          margin-top: 8px;
        }
      }
      .pre3-footer {
        // margin: 0 12px 0;
      }

      .pre1-banner {
        width: 252px;
        height: 140px;
        background-size: cover;
        display: block;
        margin: 0 auto;
        object-fit: cover;
      }
      .pre2-banner {
        width: 222px;
        height: 125px;
        background-size: cover;
        display: block;
        margin: 127px auto 0;
        object-fit: cover;
      }
      .curActive0-icon,
      .curActive1-icon,
      .curActive2-icon,
      .curActive3-icon {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 30px;
        height: 30px;
        z-index: 3;
      }
      .curActive0-bg,
      .curActive1-bg,
      .curActive2-bg,
      .curActive3-bg {
        position: absolute;
        right: 0;
        bottom: 0;
        left: 0;
        top: 0;
        z-index: 3;
        background: rgba(0, 0, 0, 0.3);
        z-index: 2;
      }
      .curActive0-bg,
      .curActive1-bg {
        top: 16px;
        bottom: 16px;
      }
      .curActive0-icon,
      .curActive1-icon {
        bottom: 16px;
      }
      .load-bg-btn {
        height: 40px;
        font-size: 16px;
        margin: 0 24px;
        display: block;
        width: calc(100% - 48px);
      }
      #posterIimg {
        position: absolute;
        top: -20000px;
        z-index: 999;
        // border: 1px solid red;
      }
    }
  }
}
.paint-wrap {
  position: absolute;
  top: -20000px;
}
.f12 {
  font-size: 12px;
}
.gray {
  color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/components/manageFooter.vue